export const noticeUris = {
  root: "notices",
  newNotice: "notices/new",
  notice: ":noticeId",
  editNotice: "notices/:id/edit",
};
